<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Nominal EDC`" :modal-id="`modal-ringkasan`" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black">
                    <div class="d-grid-12 f-16 p-d-16">
                        <label class="grid-cspan-8 m-d-0">Saldo aktif semua EDC</label>
                        <label class="grid-cspan-4 text-right m-d-0">{{ dataMesinEdc.saldo | currency }}</label>
                        <label class="grid-cspan-12 f-c-midgrey f-14 m-d-0">Total {{ dataMesinEdc.total }} Mesin</label>
                    </div>
                    <div class="f-14 f-c-midgrey p-t-16 m-d-12">
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8 3.83337V13.1667"
                                stroke="#6F7287"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12.6668 8.5L8.00016 13.1667L3.3335 8.5"
                                stroke="#6F7287"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <label class="m-d-0">Saldo aktif di setiap outlet</label>
                    </div>
                    <div
                        class="f-16 d-grid-12 p-y-8"
                        v-for="(outlet, key) in dataMesinEdc.data"
                        :key="`${key}-${outlet.idoutlet}`"
                    >
                        <img
                            v-if="outlet.logo"
                            :src="imgBucketSrc + outlet.logo"
                            class="grid-rspan-2 grid-cspan-1"
                            width="36"
                            height="36"
                        />
                        <img
                            v-else
                            src="../../../assets/gambar/Rectangle43.svg"
                            class="grid-rspan-2 grid-cspan-1"
                            width="36"
                            height="36"
                        />
                        <label class="grid-cspan-7 m-d-0 m-l-12">{{ outlet.nama_outlet }}</label>
                        <label class="grid-cspan-4 text-right m-d-0">{{ outlet.saldo | currency }}</label>
                        <label class="grid-cspan-10 f-c-midgrey f-13 m-d-0 m-l-12"
                            >{{ outlet.jumlah_mesin }} Mesin</label
                        >
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="f-12 f-c-midgrey f-regular text-left p-x-4">
                    Nominal diatas adalah saldo yang belum di-settlement. Data dari {{ dataMesinEdc.total }} Mesin,
                    mulai {{ dataMesinEdc.tglAwal }} hingga {{ dataMesinEdc.tglAkhir }}.
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import { moduleName } from "../store/state";

export default {
    name: "ModalRingkasan",
    components: {
        SOSlotModal,
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            bucketUrl: {
                dalbo: "https://storage.googleapis.com/ember-e-dalbo/",
                ages: "https://storage.googleapis.com/",
            },
            imgBucketSrc: "",
        };
    },
    mounted() {
        $(`#modal-ringkasan`).modal("show");

        this.imgBucketSrc = process.env.NODE_ENV !== "production" ? this.bucketUrl.ages : this.bucketUrl.dalbo;
    },
    computed: {
        ...mapGetters(moduleName, {
            dataMesinEdc: "dataMesinEdc",
        }),
    },
    methods: {
        async back() {
            await this.$router.push({ name: "mesin.edc.list" });
        },
        closeModal() {
            $(`#modal-ringkasan`).modal("hide");
        },
    },
};
</script>
<style scoped>
.p-x-4 {
    padding-left: 4px;
    padding-right: 4px;
}
</style>
